// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block-edit-modal[data-v-18fc3154]{max-height:82vh;overflow-y:auto;padding:20px 18px 18px}.block-edit-header[data-v-18fc3154]{align-items:center;display:flex;gap:12px;margin-bottom:18px}.block-edit-icon[data-v-18fc3154]{flex-shrink:0;height:30px;-o-object-fit:contain;object-fit:contain;width:30px}.block-edit-name[data-v-18fc3154]{color:#2b3b3b;font-size:20px;font-weight:700}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
